import { HttpHeaders, HttpParams } from '@angular/common/http';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { FieldConfig } from 'src/app/shared/models/field-config.model';
import { DataType } from 'src/app/shared/models/data-type.model';
import { FieldType } from 'src/app/shared/models/field-type.model';
import { FixedFunction } from 'src/app/shared/models/fixed-function.model';
import { Category } from 'src/app/shared/models/category.model';

const API_GET_ALL_DATA_TYPES = '/dc/data-types/get-all';
const API_GET_ALL_FIELD_TYPES = '/dc/field-types/get-all';
const API_GET_ALL_FIXED_FUNCTIONS = '/dc/fixed-functions/get-all';
const API_GET_ALL_CATEGORIES = '/dc/categories/get-all';
const API_GET_ALL_CATEGORY_FIELD = '/dc/category-fields/get-all';
const API_GET_MASTER_DATA_BY_CATEGORY = '/master-data/get-by-category/';

const API_GET_SYSTEM_MASTER_DATA_BY_CATEGORY = '/system-master-data/get-by-category/';
const API_SAVE_FIELD_CONFIG = '/dc/field-configs/save-all';
const API_DELETE_FIELD_CONFIG = '/dc/field-configs/delete-all';

@Injectable({
    providedIn: 'root'
})
export class DcFieldConfigService {

    public dataType: DataType[] = [];
    public fieldType: FieldType[] = [];
    public fixedFunction: FixedFunction[] = [];
    public categories: Category[] = [];

    constructor(private apiService: ApiService) { }

    getDataTypes() {
        return this.apiService.get(API_GET_ALL_DATA_TYPES)
            .pipe(map(res => {
                return res;
            }));
    }

    getFieldTypes() {
        return this.apiService.get(API_GET_ALL_FIELD_TYPES)
            .pipe(map(res => {
                return res;
            }));
    }

    getFixedFunctions() {
        return this.apiService.get(API_GET_ALL_FIXED_FUNCTIONS)
            .pipe(map(res => {
                return res;
            }));
    }

    getCategories() {
        return this.apiService.get(API_GET_ALL_CATEGORIES)
            .pipe(map(res => {
                return res;
            }));
    }

    getCategoryFields(categoryId: number) {
        return this.apiService.get(`${API_GET_ALL_CATEGORY_FIELD}?categoryId=${categoryId}`)
            .pipe(map(res => {
                return res;
            }));
    }

    saveFieldConfig(body: Array<FieldConfig>, templateId: number) {
        return this.apiService.post(API_SAVE_FIELD_CONFIG + '?templateId=' + templateId, body)
            .pipe(map(res => {
                return res;
            }));
    }

    deleteFieldConfig(ids: Array<number>, templateId: number) {
        return this.apiService.post(API_DELETE_FIELD_CONFIG + '?templateId=' + templateId, ids)
            .pipe(map(res => {
                return res;
            }));
    }

    getDataCategories(id: number) {
        return this.apiService.get(API_GET_MASTER_DATA_BY_CATEGORY + id)
            .pipe(map(res => {
                return res;
            }));
    }

    getSystemDataCategories(id: number) {
        return this.apiService.get(API_GET_SYSTEM_MASTER_DATA_BY_CATEGORY + id)
            .pipe(map(res => {
                return res;
            }));
    }

    getDataCategoryCurrency() {
        return this.apiService.get(`${API_GET_ALL_CATEGORIES}/currency`)
            .pipe(map(res => {
                return res;
            }));
    }

    getCategoryByParent(id: number) {
        return this.apiService.get(`${API_GET_ALL_CATEGORIES}/by-parent/${id}`)
            .pipe(map(res => {
                return res;
            }));
    }
}
